import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
//import store from './app/store';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//import { LAUNCH_PARAM_STR, HIDDEN_LAUNCH_PARAM_STR } from './page/app/constant';
//import commonConfig from './common/config/commonConfig';
//import appLoaderConverter from './converter/appLoaderConverter';
//import { persistStore } from 'redux-persist';
//import { navigate } from './redux/navAction';
import { retrieveBearerTokenAndPutToSessionStorage } from './epic/appEpic';
import { startApp } from './common/auth/bootstrap';
//import { confirmationPageEsgTmsTrackView } from 'approot/util/taggingUtils';


const renderApp = () => {
	ReactDOM.render(<App />, document.getElementById('root'));
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// function handRouteUpdate () {
//     window.scrollTo(0, 0);
// }

// const launchParamStr = window.location.search.substr("?".length) || sessionStorage.getItem(HIDDEN_LAUNCH_PARAM_STR)
// if (launchParamStr) {
//     console.log("++++Test: launchParamStr=", launchParamStr);
//     sessionStorage.clear()
//     sessionStorage.setItem(LAUNCH_PARAM_STR, launchParamStr)
// } else { 
//     console.log("++++Test: launchParamStr is null.");
// }

//function runApp() {
//const target = document.getElementById('app');

//addLocaleData([...zh,...en]);

// const app = (
//     <Provider store={store}>
//         <ValidationProvider>
//             <IntlProvider>
//                 <Router history={history} routes={createRoutes(store)} onUpdate={handRouteUpdate} />
//             </IntlProvider>
//         </ValidationProvider>
//     </Provider>
// );

// initErrorLogger();

// persistStore(store, {
//     storage: asyncSessionStorage,  
//     // whitelist: ["session"]
//     blacklist: ["errors"]
// }, ()=>{
//     render(app, target);
// })
//store.dispatch(navigate('esgHome'));
//loadIntl('esgHome');
//window.location.href = 'esg-qas-ui/#/esgHome';
//store.dispatch(navigate('esgHome'));
//confirmationPageEsgTmsTrackView();
//}

function preRunApp() {
	//handle cam0/cam30 from other system access
	//const launchParam = sessionStorage.getItem('LAUNCH_PARAM_STR');
	//const launchParams = appLoaderConverter.otherSystemDataConverter(launchParam);

	//if ( 1 === 1 ) {
	//if(launchParams !== undefined && commonConfig[launchParams.model] !== undefined && commonConfig[launchParams.model].CAM === commonConfig.MODELTYPE_CAM0){//cam0 don't logon
	//runApp();
	//} else if(launchParams !== undefined && commonConfig[launchParams.model] !== undefined && commonConfig[launchParams.model].CAM === commonConfig.MODELTYPE_CAM30){//cam30 logon
	//if(launchParams !== undefined && commonConfig[launchParams.model] !== undefined && commonConfig[launchParams.model].CAM === commonConfig.MODELTYPE_CAM30) {
	//runApp();
	return startApp(renderApp, retrieveBearerTokenAndPutToSessionStorage);
	//}
	//}
	//else {
	//runApp();
	//}
}
preRunApp();
